import React, { PropTypes } from 'react';

import { FeatureList } from '../accordions';

import { DeliveryRow, DeliveryItem, Label, Value } from './Styled';

const Lease = ({ registrationState, leaseDetails }) => {
  return (
    <section>
      <DeliveryRow>
        <DeliveryItem>
          <Label>Registration state</Label>
          <Value>{registrationState}</Value>
        </DeliveryItem>
      </DeliveryRow>

      <FeatureList list={leaseDetails} />
    </section>
  );
};

Lease.propTypes = {
  registrationState: PropTypes.string,
  leaseDetails: PropTypes.array
};

export default Lease;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/components/summary/Lease.js